import { on, createEvent, each, off } from '../helpers/shortcuts';

const shared = {
  isTouch: false,
  isMobile:
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1,
  scrollTop: window.scrollY === undefined ? window.pageYOffset : window.scrollY,
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
  hasPassiveEvents: false,
  CSS: {
    fixed: 'is-fixed',
    active: 'is-active',
    open: 'is-open',
    menuOpen: 'is-menu-open',
    desktop: 'is-desktop',
    mobile: 'is-mobile',
    locked: 'is-locked',
    invalid: 'is-invalid',
    loading: 'is-loading',
    success: 'is-success',
    visible: 'is-visible',
  },
  breakpoints: {
    xlarge: 1200,
    large: 1024,
    medium: 768,
  },
};

/* eslint-disable */
try {
  document.addEventListener('test', null, {
    get passive() {
      shared.hasPassiveEvents = true;
    },
  });
} catch (e) {}
/* eslint-enable */

const documentTouchstart = () => {
  shared.isTouch = true;
  document.documentElement.classList.remove('no-touch');
  document.documentElement.classList.add('is-touch');
  off('touchstart', document, documentTouchstart);
  on('touchstart', document.body, () => {});
  document.dispatchEvent(createEvent('touchdetected'));
};

on('touchstart', document, documentTouchstart);

each(document.querySelectorAll('[href="#"]'), link => {
  on('click', link, event => event.preventDefault());
});

on('resize', window, () => {
  shared.windowWidth = window.innerWidth;
  shared.windowHeight = window.innerHeight;
});

on('scroll', window, () => {
  shared.scrollTop =
    window.scrollY === undefined ? window.pageYOffset : window.scrollY;
});

if (shared.isMobile) {
  document.documentElement.classList.add(shared.CSS.mobile);
} else {
  document.documentElement.classList.add(shared.CSS.desktop);
}

if (/Trident\/|MSIE|Edge/i.test(window.navigator.userAgent)) {
  document.documentElement.classList.add('ie');

  if (window.navigator.userAgent.indexOf('Trident/7.0') > -1) {
    document.documentElement.classList.add('ie11');
  }
}

export default shared;



// WEBPACK FOOTER //
// ./src/scripts/modules/shared.js